// src/components/TranslationTable.tsx

import React from 'react';
import './TranslationTable.css';
import { FlattenedTranslation } from '../utils/flattenJson';

interface TranslationTableProps {
  data: FlattenedTranslation[];
  languages: string[];
  onUpdate: (key: string, language: string, value: string) => void;
  onRemoveKey: (key: string) => void;
}

const getTruncatedEnd = (fullKey: string, keepChars = 30) => {
  if (fullKey.length <= keepChars) return fullKey;
  return '...' + fullKey.slice(fullKey.length - keepChars);
};

const TranslationTable: React.FC<TranslationTableProps> = ({
  data,
  languages,
  onUpdate,
  onRemoveKey,
}) => {
  const copyKey = (key: string) => {
    navigator.clipboard.writeText(key).catch(() => {});
  };

  return (
    <table className="translation-table">
      <thead>
        <tr>
          <th className="col-num">#</th>
          <th className="col-del">Del</th>
          <th className="col-key">Key</th>
          {languages.map((lang) => (
            <th key={lang}>{lang}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item, idx) => {
          const truncatedKey = getTruncatedEnd(item.key, 30);
          return (
            <tr key={item.key}>
              <td className="col-num">{idx + 1}</td>
              <td className="col-del">
                <button onClick={() => onRemoveKey(item.key)}>🗑</button>
              </td>
              <td
                className="col-key"
                title={item.key}
                onClick={() => copyKey(item.key)}
                style={{ cursor: 'pointer' }}
              >
                {truncatedKey}
              </td>
              {languages.map((lang) => {
                const value = item.translations[lang] || '';
                const isMissing = !value;
                return (
                  <td key={lang}>
                    <textarea
                      className={isMissing ? 'missing-translation' : ''}
                      value={value}
                      onChange={(e) => onUpdate(item.key, lang, e.target.value)}
                    />
                  </td>
                );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default TranslationTable;
